// Single source of truth for "by <author>" labels across the app.
// Rules (matches backend services/author_integrity.py):
//   - Admin-authored or is_internal=true -> null (no label, no placeholder)
//   - author_missing=true                -> null (caller decides; never "Unknown Author")
//   - else                               -> author_name (already resolved by backend)
//
// NEVER returns the string "Unknown Author" or any platform-owned label
// (Feb 2026: "Storyfyc Originals" label removed entirely so admin
// presence is completely invisible on user-facing surfaces).

export const INTERNAL_LABEL = null;

/** Return the display name for a story/contract/row, or null when unknown
 *  / when the row is platform-owned / when the author is an admin. */
export const renderAuthor = (item) => {
  if (!item) return null;
  if (item.is_internal) return null;
  if (item.author_missing) return null;
  return item.author_name || null;
};

/** Returns true if the row should be kept hidden on public surfaces.
 *  Internal (admin/platform) rows stay visible — they just render with
 *  no "by …" line. Only truly broken records (no author + not internal)
 *  are hidden from public lists. */
export const shouldHideForMissingAuthor = (item) =>
  !!(item && item.author_missing && !item.is_internal);
